import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../context/user';
import { GeneralStore } from '../../stores';

export const SidebarLogoutButton = ({ collapsed }) => {
  const { t } = useTranslation();
  const [, dispatch] = useContext(UserContext);
  const navigate = useNavigate();
  const { logout, sidebarCollapsed } = GeneralStore();
  const isCollapsed = collapsed ?? sidebarCollapsed;

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    logout();
    navigate('/giris');
  };

  return (
    <Button
      type="text"
      danger
      block
      className={`spor-sidebar-logout${isCollapsed ? ' is-collapsed' : ''}`}
      icon={<LogoutOutlined />}
      onClick={handleLogout}
      aria-label={t('sidebar.logout')}
    >
      {!isCollapsed && t('sidebar.logout')}
    </Button>
  );
};
